package com.essntl.features.invoice.ui.addeditinvoice.components.content

import core.validation.Form
import core.validation.field.Field
import core.validation.field.IntField
import core.validation.validator.IntMinValidator

class CreatePaymentLinkValidator: Form() {

    val amount =
        IntField(
            IntMinValidator(
                minValue = 0,
                strict = true,
            )
        )

    override val fields: List<Field> = listOf(amount)

}